export default "__VITE_ASSET__e31fe7bd__"